import { Check } from 'lucide-react';
import { ClientBadge } from '@/components/Inventory/UserSecurityPostureTab/ClientBadge';

interface FilterOptionProps {
  value: string;
  isSelected: boolean;
}

export function ClientFilterOption({ value, isSelected }: FilterOptionProps) {
  return (
    <div className="flex items-center gap-2">
      {isSelected && <Check className="h-3.5 w-3.5 text-primary shrink-0" />}
      <ClientBadge client={value} showTooltip={false} />
    </div>
  );
}
